module.exports = __webpack_public_path__ + "static/media/transit.e75eb66f.svg";